import axios from 'axios';

export const getConfigs = () => {
  return axios.get('/api/config');
};
